// extracted by mini-css-extract-plugin
export default {"accept_offer_button":"SellerListingOffersTable_accept_offer_button__ctnZ3","spin":"SellerListingOffersTable_spin__TX0WO"};